<template>
  <div class="form-wrapper">
    <ElForm ref="form" class="elementui-common-form-styles" v-highlight label-width="50" inline>
      <ElFormItem label="媒体">
        <ElSelect
          style="width: 180px"
          size="small"
          v-model="filterForm.mediaIds"
          placeholder="全部"
          multiple
          clearable
          filterable
          collapse-tags
        >
          <ElOption v-for="media in MEDIAS" :key="media.mediaId" :label="media.mediaName" :value="media.mediaId"> </ElOption>
        </ElSelect>
      </ElFormItem>

      <ElFormItem label="项目组">
        <ElSelect
          style="width: 180px"
          size="small"
          v-model="filterForm.projectGroupOpIds"
          placeholder="全部"
          multiple
          clearable
          filterable
          collapse-tags
        >
          <ElOption v-for="g in PROJECT_GROUP" :key="g.id" :label="g.name" :value="g.id"> </ElOption>
        </ElSelect>
      </ElFormItem>

      <ElFormItem label="应用组">
        <ElSelect
          style="width: 180px"
          size="small"
          v-model="filterForm.gameGroupIds"
          placeholder="全部"
          multiple
          clearable
          filterable
          collapse-tags
        >
          <ElOption v-for="g in GAME_GROUPS" :key="g.id" :label="g.name" :value="g.id"> </ElOption>
        </ElSelect>
      </ElFormItem>

      <ElFormItem label="应用">
        <ElSelect
          style="width: 180px"
          size="small"
          v-model="filterForm.gameIds"
          placeholder="全部"
          multiple
          clearable
          transfer
          filterable
          collapse-tags
        >
          <ElOption v-for="a in GAMES" :key="a.id" :label="a.name" :value="a.id"> </ElOption>
        </ElSelect>
      </ElFormItem>

      <ElFormItem label="人员">
        <ElSelect
          style="width: 180px"
          size="small"
          v-model="filterForm.opIds"
          placeholder="全部"
          clearable
          multiple
          filterable
          collapse-tags
        >
          <ElOption v-for="o in PTOM_USERS" :key="o.id" :label="o.name" :value="o.id"> </ElOption>
        </ElSelect>
      </ElFormItem>

      <ElFormItem label="账号">
        <ElSelect
          style="width: 180px"
          size="small"
          v-model="filterForm.adAccountIdList"
          placeholder="全部"
          multiple
          clearable
          filterable
          collapse-tags
        >
          <ElOption v-for="a in MEDIA_ACCOUNTS" :key="a.id" :label="a.name" :value="a.id"> </ElOption>
        </ElSelect>
      </ElFormItem>

      <ElFormItem label-width="0">
        <ElSelect style="width: 70px" size="small" v-model="filterForm.dateType">
          <ElOption v-for="date in dateRanges" :key="date.value" :label="date.label" :value="date.value"> </ElOption>
        </ElSelect>
      </ElFormItem>

      <ElFormItem v-if="filterForm.dateType === 7" label-width="0">
        <ElDatePicker
          v-model="filterForm.dateRange"
          type="daterange"
          placeholder="请选择日期"
          style="width: 200px"
          :clearable="false"
          :picker-options="dateOptions"
        ></ElDatePicker>
      </ElFormItem>

      <slot name="query-btn" />
      <ElButton @click="$emit('clear')">清空</ElButton>

      <DropdownNavigator style="margin-left: 10px" button-type="none" v-if="$store.state.accessAuth.includes('M20987')"></DropdownNavigator>
    </ElForm>
  </div>
</template>
<script>
import { miniProgramDateRanges } from '../../consts/index.js'
import { initPageData, PROJECT_GROUP, GAME_GROUPS, GAMES, MEDIA_ACCOUNTS, PTOM_USERS, MEDIAS } from '@/data/global-opts'
import DropdownNavigator from '@/components/new-plan-dropdown-nav'

const PAGE_REQUIRED_OPTS = initPageData([PROJECT_GROUP, GAME_GROUPS, GAMES, MEDIA_ACCOUNTS, PTOM_USERS, MEDIAS])

export default {
  props: ['filterForm'],
  components: { DropdownNavigator },
  data() {
    return {
      dateOptions: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        }
      }
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    dateRanges() {
      return miniProgramDateRanges
    }
  }
}
</script>
<style lang="scss" scoped>
.el-select {
  color: red !important;
}
</style>
